module.exports = __webpack_public_path__ + "pacientI.png";